import * as authService from "@hub/authentication/src/services/auth.service"
import { saveSessionToLocalStorage } from "@shared/helpers/src/localStorage.helper"
import createDateFormat from "@shared/factories/src/dateFormat.factory"
import { resetDefaultHeaders } from "@shared/factories/src/http.factory"

export default {
  updateAccessAndLockedStatus({ commit }, payload) {
    localStorage.setItem("access_blocked", JSON.stringify(payload))
  },
  async login({ dispatch, commit }, payload) {
    dispatch("stopCounter")
    try {
      const data = await authService.login({
        credential: payload.credential,
        password: payload.password,
      })

      dispatch("resetCounters")
      dispatch("updateStateLogin", data)
      commit("updateIsMobile", payload.isMobile)
      saveSessionToLocalStorage(data)
    } catch (error) {
      throw error
    }
  },

  updateStateLogin({ commit, dispatch }, payload) {
    const { user, first_access, access_token, token_type, provider, tenant, dashboard } = payload
    const capitalizedTokenType =
      token_type.charAt(0).toUpperCase() + token_type.slice(1)
    const lastAccessAt = createDateFormat(new Date()).format(
      "DD/MM/YYYY [às] HH[h]mm"
    )
    const expirationTime = user?.security?.auth?.maximum_user_downtime
    const shouldRenewSession = Boolean(expirationTime) && expirationTime !== 0
    const mfaValidated = user?.security?.auth?.mfa_validated
    const geolocationRequired = user?.security?.geolocation_required
    const { contact_confirmation } = user

    dispatch(
      "updateAccessAndLockedStatus",
      first_access || user.security.password_locked
    )
    commit("updateFirstAccess", first_access)
    commit("updateUser", user)
    commit("updateProvider", provider)
    commit("updateTenant", tenant)
    commit("updateDashboard", dashboard)
    commit("updateToken", capitalizedTokenType + " " + access_token)
    commit("updateLastAccessAt", lastAccessAt)
    commit("updateExpirationTime", expirationTime)
    commit("updateExpirationTimeInSeconds", expirationTime * 60)
    commit("updateShouldRenewSession", shouldRenewSession)
    commit(
      "updateTermOfUseSigned",
      !user?.term_of_use?.term_of_use_needs_to_be_signed
    )
    commit("updateMfaValidated", mfaValidated)
    commit("updateGeolocationRequired", geolocationRequired)
    commit("setUserEmailValidated", contact_confirmation?.is_email_confirmed)
    commit("setUserPhoneValidated", contact_confirmation?.is_phone_confirmed)
    commit("setCanSkipContactValidation", contact_confirmation?.can_skip)
    commit("setShowModalUserContactsConfirmation", contact_confirmation?.needs_confirmation)

    if (contact_confirmation?.deadline_at) {
      dispatch("calcDaysToContactsValidationDealine", contact_confirmation?.deadline_at)
    }
    commit("Order/Client/updateCompanyTypesOptions", [], { root: true })
  },
  async logout({ commit, dispatch }) {
    await new Promise(resolve => {
      dispatch("updateAccessAndLockedStatus", false)
      dispatch("resetCounters")
      commit("updateFirstAccess", false)
      commit("updateUser", {})
      commit("updateProvider", {})
      commit("updateDashboard")
      commit("updateToken", "")
      commit("updateMessageToast", {})
      commit("updateLastAccessAt", "")
      commit("updateMfaValidated", false)
      dispatch("Core/resetCurrentCoordinates", null, {root: true})
      resetDefaultHeaders()

      resolve()
    })

    window.$vue?.$router?.push({ name: "hub" })
  },
  async handlesChangeUserPhoto({ state, commit }, image) {
    await authService.changeMyUserPhoto(state.user.uuid, {
      image
    })

    commit("updatePhoto", image)
  },
  async startCounter({ state, commit }) {
    if (!state.sessionTime.shouldRenewSession) return
    while (state.sessionTime.expirationTimeInSeconds > 0) {
      await new Promise(resolve => setTimeout(resolve, 1000))
      commit(
        "updateExpirationTimeInSeconds",
        state.sessionTime.expirationTimeInSeconds - 1
      )
    }

    commit("updateTimeExpired", true)
  },
  async stopCounter({ commit }) {
    await commit("updateExpirationTimeInSeconds", 0)
  },
  async resetCounters({ commit, state }) {
    const lastAccessAt = createDateFormat(new Date()).format(
      "DD/MM/YYYY [às] HH[h]mm"
    )

    await commit("updateShowModalLogin", false)
    await commit("updateLastAccessAt", lastAccessAt)
    await commit(
      "updateExpirationTimeInSeconds",
      state.sessionTime.expirationTime * 60
    )
    await commit("updateTimeExpired", false)
  },
  calcDaysToContactsValidationDealine ({ commit }, deadline) {
    const todaysDate = new Date().setHours(0, 0, 0, 0)
    const deadlineDate = new Date(deadline).setHours(0, 0, 0, 0)

    const daysInSecondsToContactsDealine = (deadlineDate - todaysDate) / 1000
    const daysInHoursToContactsDealine = daysInSecondsToContactsDealine / 3600
    const fullDaysToContactsDealine = daysInHoursToContactsDealine / 24

    commit("setDaysToContactValidationDeadline", fullDaysToContactsDealine)
  }
}
